//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'customerProfile',
  data(){
    return {
      loading:false,
      errorText:'',
      profile:null,
      types:{
        guest:{label:'散客',color:'#8A94A6'},
        stored:{label:'储值客户',color:'#16B5A0'},
        times:{label:'次卡客户',color:'#2D7FF9'},
        annual:{label:'年卡客户',color:'#7C5CFC'},
        discount:{label:'折扣卡客户',color:'#E99A17'},
        times_exhausted:{label:'次卡已用完散客',color:'#D98714'},
        expired_guest:{label:'过期会员卡散客',color:'#C45A5A'}
      }
    }
  },
  computed:{
    shopTitle(){
      if(!this.profile) return '客户到店提醒';
      return [this.profile.brand_name,this.profile.store_name].filter(function(value){ return value; }).join(' · ') || '客户到店提醒';
    },
    typeMeta(){
      return this.types[this.profile && this.profile.type] || this.types.guest;
    },
    customerType(){
      return this.profile && this.profile.customer_type ? this.profile.customer_type : this.typeMeta.label;
    },
    avatarText(){
      var name = this.profile && this.profile.name ? this.profile.name : '?';
      return name.charAt(0);
    },
    maskedPhone(){
      var phone = this.profile && this.profile.phone ? String(this.profile.phone) : '';
      return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
    memberRows(){
      var profile = this.profile || {};
      var rows = [{label:'客户类型',value:this.customerType}];
      if(Array.isArray(profile.memberships) && profile.memberships.length){
        profile.memberships.forEach(function(membership){
          rows.push({label:'卡名称',value:membership.card_name || '会员卡'});
          (membership.rights || []).forEach(function(right){
            rows.push({label:right.label,value:right.value,highlight:Number(right.highlight) === 1});
          });
        });
      }else if(profile.type === 'guest'){
        rows.push({label:'会员卡',value:'未开通',muted:true});
      }else{
        rows.push({label:'卡名称',value:profile.card_name || '会员卡'});
        if(profile.type === 'stored') rows.push({label:'储值余额',value:'¥'+(profile.balance || '0.00'),highlight:true});
        if(profile.type === 'times') rows.push({label:'剩余次数',value:(profile.remain || 0)+' / '+(profile.total || 0)+' 次',highlight:true});
        if(profile.type === 'annual') rows.push({label:'到期时间',value:profile.expire || '-',highlight:true});
        if(profile.type === 'discount'){
          rows.push({label:'会员折扣',value:profile.discount || '专享',highlight:true});
          rows.push({label:'到期时间',value:profile.expire || '-'});
        }
      }
      return rows;
    }
  },
  created(){
    this.openProfile();
  },
  methods:{
    openProfile(){
      if(!this.$func.getLocal('token')){
        this.$func.setLocal('login_redirect', this.$route.fullPath);
        this.$router.replace({path:'/login',query:{redirect:this.$route.fullPath}});
        return;
      }
      this.loadProfile();
    },
    loadProfile(){
      var phone = String(this.$route.query.phone || '').trim();
      var cid = Number(this.$route.query.cid) || 0;
      if(!/^1\d{10}$/.test(phone) || !cid){
        this.errorText = '客户手机号或门店参数不正确';
        return;
      }
      this.loading = true;
      this.errorText = '';
      this.$api.customerProfile({phone:phone,cid:cid}).then((res)=>{
        this.loading = false;
        if(res && Number(res.code) === 2){
          this.$func.setLocal('login_redirect', this.$route.fullPath);
          this.$router.replace({path:'/login',query:{redirect:this.$route.fullPath}});
          return;
        }
        if(res && res.data){
          this.profile = res.data;
          return;
        }
        this.errorText = '未查询到客户会员信息';
      }).catch(()=>{
        this.loading = false;
        this.errorText = '客户信息加载失败，请稍后重试';
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/customerProfile.vue